// Kanonische Schadensart-Liste, abgeleitet aus den realen Import-„Sparte"-Werten
// (ImportKMVS_SchadenBasis.txt, Spalte „Sparte"), gruppiert nach Risiko-Typ des
// Wizards. Wird im „Neuer Schaden"-Fenster als Auswahl am Ende angeboten und 1:1
// in Damage.damageType geschrieben — konsistent mit der importierten Anzeige.
import type { BigDamageType } from "./types";

export const SCHADENSARTEN: Record<BigDamageType, string[]> = {
  gebaeude: [
    "Leitungswasser",
    "Feuer",
    "Sturm/Hagel",
    "Glas",
    "Elementar",
    "Einbruchdiebstahl und Raub",
    "Gebäude Sonstige Gefahren",
    "Technische Versicherung",
    "Politische Gefahren",
    "Häuslicher Bereich",
  ],
  kfz: [
    "Kraftfahrzeug-Haftpflicht",
    "Teilkasko",
    "Vollkasko",
    "Vollkasko Schutzbrief",
  ],
  sonstiges: [
    "Allgemeine Haftpflicht",
    "Produkthaftpflicht",
    "Sonstiger Unfall außerh.Haus",
    "Sonstiger Unfall innerh.Haus",
    "Reisegepäck",
    "Transport / Warentransport",
    "All Risk Deckungen",
    "Wegeunfall",
  ],
};

/** Gemeinsamer „Sonstige"-Eintrag (Freitext-fallback) für jede Gruppe. */
export const SCHADENSART_SONSTIGE = "Sonstige";

export function schadensartenFor(type: BigDamageType | null): string[] {
  if (!type) return [];
  return [...SCHADENSARTEN[type], SCHADENSART_SONSTIGE];
}
